import { render, staticRenderFns } from "./SecurityServerSettingGuide.vue?vue&type=template&id=73fa22c9&scoped=true&"
import script from "./SecurityServerSettingGuide.vue?vue&type=script&lang=ts&"
export * from "./SecurityServerSettingGuide.vue?vue&type=script&lang=ts&"
import style0 from "./SecurityServerSettingGuide.vue?vue&type=style&index=0&id=73fa22c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fa22c9",
  null
  
)

export default component.exports